import React from "react";
import Label from "../Label";

const FormTextAreaField = ({
  label,
  name,
  id,
  rows,
  cols,
  placeholder,
  value,
  onChange,
  readOnly,
  error,
}) => {
  return (
    <>
      <div
        className={`form-textarea-wrapper ${
          readOnly
            ? "form-textarea-readonly"
            : error
            ? "form-textarea-error"
            : "form-textarea-default"
        }`}
      >
        <Label htmlFor={id} className="form-textarea-label" text={label} />
        <textarea
          name={name}
          id={id}
          rows={rows}
          cols={cols}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          placeholder={placeholder}
          className="form-textarea-field"
        />
      </div>
      {error && <span className="form-textarea-error-text">{error}</span>}
    </>
  );
};

export default FormTextAreaField;
